export default "__VITE_ASSET__a1918887__"